import React from 'react';
import Typo from '@/src/components/atom/Typo';
import Button from '@/src/components/atom/Button';

function NotFoundPage() {
  return (
    <section className="flex h-screen flex-col items-center justify-center gap-4 whitespace-pre-wrap text-center">
      <figure className="h-[320px] w-[320px]">
        <img
          src="/assets/images/img-404.png"
          width={320}
          height={320}
          alt="page not found"
        />
      </figure>
      <Typo color="gray2" typoType="b16m">
        찾을 수 없는 페이지 입니다.\n요청하신 페이지가 사라졌거나, 잘못된 경로로
        접근하였습니다.
      </Typo>
      <Button style={{ width: '158px' }} onClick={() => window.history.back()}>
        이전 화면으로 이동
      </Button>
    </section>
  );
}

export default NotFoundPage;
